import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReflectionData } from '@pages/member/skill-builder/reflection/common';
import { DomainService } from '@services/public';
import { config } from 'environment';
import { domainUID, skillUID } from 'jakapa-utilities-lite';
import { Observable } from 'rxjs';

export interface ReflectionSkillScore {
	uid: skillUID;
	score: number;
}

export interface ReflectionServiceViewResponse {
	self: Array<ReflectionSkillScore>;
	peer: Array<ReflectionSkillScore>;
}

export interface ReflectionServiceCreateLogResponse {
	goalPlanUUID: string;
}

@Injectable({
	providedIn: 'root',
})
export class ReflectionService {
	constructor(
		private _domainSvc: DomainService,
		private _http: HttpClient,
	) {}

	view(domainUID: domainUID): Observable<ReflectionServiceViewResponse> {
		return this._http.get<ReflectionServiceViewResponse>(
			`${config.apiBase}member/skill-builder/reflection/view?domainUID=${domainUID}`,
		);
	}

	createLog(
		data: ReflectionData,
	): Observable<ReflectionServiceCreateLogResponse> {
		return this._http.post<ReflectionServiceCreateLogResponse>(
			`${config.apiBase}member/skill-builder/reflection/create-log`,
			{
				domainUID: data.domainUID,
				cycle: data.cycle,
				skillScores: data.scores,
				insight: data.insight,
				skillUID: data.skillUID,
				skillName: this._domainSvc.getSkill(data.skillUID).name,
				action: data.action,
				skillBuilder: data.skillBuilderType,
			},
		);
	}
}
